import taskManagerApi from "@/features/shared/services/taskManagerApi";
export const fetchTaskComments = async (taskId) => {
    const { data } = await taskManagerApi.get(`/comments/task/${taskId}`);
    return data.data.comments;
};
export const addComment = async (taskId, body) => {
    const { data } = await taskManagerApi.post(`/comments/task/${taskId}`, body);
    return data.data.comment;
};
export const updateComment = async (id, body) => {
    const { data } = await taskManagerApi.put(`/comments/${id}`, body);
    return data.data.comment;
};
export const deleteComment = async (id) => {
    await taskManagerApi.delete(`/comments/${id}`);
};
